export default {
  components: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        padding: 16,
        '&::before': {
          display: 'none'
        },
        '&:first-of-type': {
          borderTopRightRadius: 16,
          borderTopLeftRadius: 16
        },
        '&:last-of-type': {
          borderBottomRightRadius: 16,
          borderBottomLeftRadius: 16
        }
      }
    }
  }
};
